/** Fixed preview length so Bablic sees the same translatable text on all devices. */
export const DESCRIPTION_PREVIEW_MAX_CHARS = 180;
